import { render, staticRenderFns } from "./CIcon.vue?vue&type=template&id=dba451c2"
import script from "./CIcon.vue?vue&type=script&lang=js"
export * from "./CIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports